(function () {
  document.querySelectorAll('.pdp-perfect-for').forEach(function (wrapper) {
    // Moved to <body> so position:fixed centers on the real viewport, not a
    // transformed ancestor (e.g. the product gallery/carousel), which otherwise
    // turns `fixed` into a containing-block-relative position.
    wrapper.querySelectorAll('[data-pf-overlay]').forEach(function (overlay) {
      document.body.appendChild(overlay);
    });

    wrapper.querySelectorAll('[data-pf-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var id = trigger.getAttribute('data-pf-trigger');
        var overlay = document.querySelector('[data-pf-overlay="' + id + '"]');
        if (overlay) overlay.hidden = false;
      });
    });
  });

  document.querySelectorAll('[data-pf-overlay]').forEach(function (overlay) {
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) overlay.hidden = true;
    });

    var closeBtn = overlay.querySelector('[data-pf-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        overlay.hidden = true;
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-pf-overlay]').forEach(function (overlay) {
      if (!overlay.hidden) overlay.hidden = true;
    });
  });
})();
